export default __webpack_public_path__ + "static/sherveen-mashayekhi-b6e2e3e080c79eff2c2fe764c73b1c22.png";